"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossMarginCFD__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "collateral_",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "DelegateDoesNotExist",
        type: "error",
    },
    {
        inputs: [],
        name: "DifferentInstrumentIndexes",
        type: "error",
    },
    {
        inputs: [],
        name: "IncorrectInstrumentIndexes",
        type: "error",
    },
    {
        inputs: [],
        name: "IncorrectOrder",
        type: "error",
    },
    {
        inputs: [],
        name: "IncorrectSenderAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "InstrumentDoesNotExist",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientMargin",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidationOfPositionInProfit",
        type: "error",
    },
    {
        inputs: [],
        name: "MaxOpenPositionsExceeded",
        type: "error",
    },
    {
        inputs: [],
        name: "NegativeEquityAfterLiquidation",
        type: "error",
    },
    {
        inputs: [],
        name: "NotApprovedMatcher",
        type: "error",
    },
    {
        inputs: [],
        name: "OrderIsAlreadyFilled",
        type: "error",
    },
    {
        inputs: [],
        name: "PriceOfLiquidatedInstrumentNotFirst",
        type: "error",
    },
    {
        inputs: [],
        name: "SufficientMargin",
        type: "error",
    },
    {
        inputs: [],
        name: "WithdrawMoreThanBalance",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "liquidatedInstrument",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint112",
                name: "liquidationFee",
                type: "uint112",
            },
            {
                indexed: false,
                internalType: "int112",
                name: "balance",
                type: "int112",
            },
            {
                indexed: false,
                internalType: "int112",
                name: "realizedPNL",
                type: "int112",
            },
            {
                indexed: false,
                internalType: "int112",
                name: "realizedFR",
                type: "int112",
            },
        ],
        name: "AccountLiquidated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oracle",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "delegateStorage",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "fundingRateAccount",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "soLevel",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint16",
                name: "withdrawMarginLevel",
                type: "uint16",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "maxOpenPositions",
                type: "uint256",
            },
        ],
        name: "BasicParamsUpdate",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "int112",
                name: "soLevel",
                type: "int112",
            },
        ],
        name: "CustomStopOutLevelUpdate",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "int112",
                name: "amount",
                type: "int112",
            },
            {
                indexed: false,
                internalType: "int112",
                name: "finalBalance",
                type: "int112",
            },
        ],
        name: "DepositBalanceChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string[12]",
                name: "ticker",
                type: "string[12]",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "leverage",
                type: "uint8",
            },
        ],
        name: "InstrumentUpdate",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "int48",
                name: "frLongPerSecond",
                type: "int48",
            },
            {
                indexed: false,
                internalType: "int48",
                name: "frShortPerSecond",
                type: "int48",
            },
            {
                indexed: false,
                internalType: "int72",
                name: "longFRStored",
                type: "int72",
            },
            {
                indexed: false,
                internalType: "int72",
                name: "shortFRStored",
                type: "int72",
            },
        ],
        name: "NewFundingRate",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "buyer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "seller",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint80",
                name: "filledPrice",
                type: "uint80",
            },
            {
                indexed: false,
                internalType: "uint192",
                name: "filledAmount",
                type: "uint192",
            },
        ],
        name: "NewTrade",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: false,
                internalType: "int112",
                name: "balance",
                type: "int112",
            },
            {
                components: [
                    {
                        internalType: "int112",
                        name: "position",
                        type: "int112",
                    },
                    {
                        internalType: "int112",
                        name: "frAccumulated",
                        type: "int112",
                    },
                    {
                        internalType: "uint32",
                        name: "positionLastUpdate",
                        type: "uint32",
                    },
                    {
                        internalType: "uint80",
                        name: "positionAvgPrice",
                        type: "uint80",
                    },
                    {
                        internalType: "int72",
                        name: "positionLongFRStored",
                        type: "int72",
                    },
                    {
                        internalType: "int72",
                        name: "positionShortFRStored",
                        type: "int72",
                    },
                ],
                indexed: false,
                internalType: "struct CFD.PositionInfo",
                name: "position",
                type: "tuple",
            },
            {
                indexed: false,
                internalType: "int112",
                name: "realizedPNL",
                type: "int112",
            },
            {
                indexed: false,
                internalType: "int112",
                name: "realizedFR",
                type: "int112",
            },
        ],
        name: "PositionUpdate",
        type: "event",
    },
    {
        inputs: [],
        name: "accountsWithOpenPositionLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string[12]",
                name: "ticker",
                type: "string[12]",
            },
            {
                internalType: "uint8",
                name: "leverage",
                type: "uint8",
            },
            {
                internalType: "int256",
                name: "dailyFRLong",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "dailyFRShort",
                type: "int256",
            },
        ],
        name: "addInstrument",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "allowedMatchers",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "balances",
        outputs: [
            {
                internalType: "int112",
                name: "",
                type: "int112",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "uint16",
                        name: "index",
                        type: "uint16",
                    },
                    {
                        internalType: "uint80",
                        name: "price",
                        type: "uint80",
                    },
                ],
                internalType: "struct LibValidatorMultiCFD.PriceInfo[]",
                name: "prices",
                type: "tuple[]",
            },
            {
                internalType: "bool",
                name: "checkPrices",
                type: "bool",
            },
        ],
        name: "calculateMarginLevel",
        outputs: [
            {
                internalType: "int112",
                name: "marginLevel",
                type: "int112",
            },
            {
                internalType: "int112",
                name: "equity",
                type: "int112",
            },
            {
                internalType: "int112",
                name: "margin",
                type: "int112",
            },
            {
                internalType: "int112[]",
                name: "pnls",
                type: "int112[]",
            },
            {
                internalType: "int112[]",
                name: "frs",
                type: "int112[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                internalType: "string[12]",
                name: "ticker",
                type: "string[12]",
            },
            {
                internalType: "uint8",
                name: "leverage",
                type: "uint8",
            },
            {
                internalType: "int256",
                name: "dailyFRLong",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "dailyFRShort",
                type: "int256",
            },
        ],
        name: "changeInstrument",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "int112",
                name: "marginLevel",
                type: "int112",
            },
        ],
        name: "checkMarginWithOraclePrices",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
            {
                internalType: "int112",
                name: "",
                type: "int112",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "collateral",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "trader",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "call_data",
                type: "bytes",
            },
        ],
        name: "delegatedAction",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint112",
                name: "amount",
                type: "uint112",
            },
        ],
        name: "depositAsset",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint112",
                name: "amount",
                type: "uint112",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
        ],
        name: "depositAssetTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "senderAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "matcherAddress",
                        type: "address",
                    },
                    {
                        internalType: "uint16",
                        name: "instrumentIndex",
                        type: "uint16",
                    },
                    {
                        internalType: "uint96",
                        name: "amount",
                        type: "uint96",
                    },
                    {
                        internalType: "uint80",
                        name: "price",
                        type: "uint80",
                    },
                    {
                        internalType: "uint64",
                        name: "matcherFee",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "expiration",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "buySide",
                        type: "uint8",
                    },
                    {
                        internalType: "bool",
                        name: "isFromDelegate",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct LibValidatorMultiCFD.Order",
                name: "buyOrder",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "senderAddress",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "matcherAddress",
                        type: "address",
                    },
                    {
                        internalType: "uint16",
                        name: "instrumentIndex",
                        type: "uint16",
                    },
                    {
                        internalType: "uint96",
                        name: "amount",
                        type: "uint96",
                    },
                    {
                        internalType: "uint80",
                        name: "price",
                        type: "uint80",
                    },
                    {
                        internalType: "uint64",
                        name: "matcherFee",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "expiration",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "buySide",
                        type: "uint8",
                    },
                    {
                        internalType: "bool",
                        name: "isFromDelegate",
                        type: "bool",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct LibValidatorMultiCFD.Order",
                name: "sellOrder",
                type: "tuple",
            },
            {
                internalType: "uint80",
                name: "filledPrice",
                type: "uint80",
            },
            {
                internalType: "uint96",
                name: "filledAmount",
                type: "uint96",
            },
        ],
        name: "fillOrders",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "filledAmounts",
        outputs: [
            {
                internalType: "uint96",
                name: "",
                type: "uint96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fundingRateAccount",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getAccountFR",
        outputs: [
            {
                internalType: "int112",
                name: "",
                type: "int112",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "offset",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "limit",
                type: "uint256",
            },
        ],
        name: "getAccountsWithOpenPositions",
        outputs: [
            {
                internalType: "address[]",
                name: "res",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getActiveInstrumentsIndexes",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getActiveInstrumentsPositions",
        outputs: [
            {
                internalType: "uint256[]",
                name: "indexes",
                type: "uint256[]",
            },
            {
                components: [
                    {
                        internalType: "int112",
                        name: "position",
                        type: "int112",
                    },
                    {
                        internalType: "int112",
                        name: "frAccumulated",
                        type: "int112",
                    },
                    {
                        internalType: "uint32",
                        name: "positionLastUpdate",
                        type: "uint32",
                    },
                    {
                        internalType: "uint80",
                        name: "positionAvgPrice",
                        type: "uint80",
                    },
                    {
                        internalType: "int72",
                        name: "positionLongFRStored",
                        type: "int72",
                    },
                    {
                        internalType: "int72",
                        name: "positionShortFRStored",
                        type: "int72",
                    },
                ],
                internalType: "struct CFD.PositionInfo[]",
                name: "positions",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getAssetPrice",
        outputs: [
            {
                internalType: "int112",
                name: "price",
                type: "int112",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getDelegateStorage",
        outputs: [
            {
                internalType: "address",
                name: "delegateStorage",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getInstrumentInfo",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "leverage",
                        type: "uint8",
                    },
                    {
                        internalType: "string[12]",
                        name: "ticker",
                        type: "string[12]",
                    },
                    {
                        components: [
                            {
                                internalType: "int40",
                                name: "frLong",
                                type: "int40",
                            },
                            {
                                internalType: "int40",
                                name: "frShort",
                                type: "int40",
                            },
                            {
                                internalType: "int72",
                                name: "longFRStored",
                                type: "int72",
                            },
                            {
                                internalType: "int72",
                                name: "shortFRStored",
                                type: "int72",
                            },
                            {
                                internalType: "uint32",
                                name: "lastFRUpdateTime",
                                type: "uint32",
                            },
                        ],
                        internalType: "struct CFD.FundingRateInfo",
                        name: "fundingRateInfo",
                        type: "tuple",
                    },
                ],
                internalType: "struct CFD.InstrumentInfo",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "offset",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "limit",
                type: "uint256",
            },
        ],
        name: "getOpenPositions",
        outputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        components: [
                            {
                                internalType: "int112",
                                name: "position",
                                type: "int112",
                            },
                            {
                                internalType: "int112",
                                name: "frAccumulated",
                                type: "int112",
                            },
                            {
                                internalType: "uint32",
                                name: "positionLastUpdate",
                                type: "uint32",
                            },
                            {
                                internalType: "uint80",
                                name: "positionAvgPrice",
                                type: "uint80",
                            },
                            {
                                internalType: "int72",
                                name: "positionLongFRStored",
                                type: "int72",
                            },
                            {
                                internalType: "int72",
                                name: "positionShortFRStored",
                                type: "int72",
                            },
                        ],
                        internalType: "struct CFD.PositionInfo[]",
                        name: "positions",
                        type: "tuple[]",
                    },
                ],
                internalType: "struct CFD.AccountPositions[]",
                name: "positions",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                internalType: "int112",
                name: "price",
                type: "int112",
            },
        ],
        name: "getPNL",
        outputs: [
            {
                internalType: "int112",
                name: "",
                type: "int112",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getSenderOverride",
        outputs: [
            {
                internalType: "address",
                name: "senderOverride",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getTotalLongFR",
        outputs: [
            {
                internalType: "int72",
                name: "",
                type: "int72",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getTotalShortFR",
        outputs: [
            {
                internalType: "int72",
                name: "",
                type: "int72",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "oracle_",
                type: "address",
            },
            {
                internalType: "address",
                name: "delegateStorage",
                type: "address",
            },
            {
                internalType: "address",
                name: "fundingRateAccount_",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "maxOpenPositions_",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "soLevel_",
                type: "uint8",
            },
            {
                internalType: "uint16",
                name: "withdrawMarginLevel_",
                type: "uint16",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "instrumentsLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "accountToLiquidate",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "liquidator",
                        type: "address",
                    },
                    {
                        internalType: "uint16",
                        name: "index",
                        type: "uint16",
                    },
                    {
                        components: [
                            {
                                internalType: "uint16",
                                name: "index",
                                type: "uint16",
                            },
                            {
                                internalType: "uint80",
                                name: "price",
                                type: "uint80",
                            },
                        ],
                        internalType: "struct LibValidatorMultiCFD.PriceInfo[]",
                        name: "prices",
                        type: "tuple[]",
                    },
                    {
                        internalType: "uint64",
                        name: "liquidationTimestamp",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "expiration",
                        type: "uint64",
                    },
                    {
                        internalType: "bytes",
                        name: "signature",
                        type: "bytes",
                    },
                ],
                internalType: "struct LibValidatorMultiCFD.LiquidationOrder",
                name: "liquidationOrder",
                type: "tuple",
            },
        ],
        name: "liquidatePosition",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "oracle",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "positionInfo",
        outputs: [
            {
                internalType: "int112",
                name: "position",
                type: "int112",
            },
            {
                internalType: "int112",
                name: "frAccumulated",
                type: "int112",
            },
            {
                internalType: "uint32",
                name: "positionLastUpdate",
                type: "uint32",
            },
            {
                internalType: "uint80",
                name: "positionAvgPrice",
                type: "uint80",
            },
            {
                internalType: "int72",
                name: "positionLongFRStored",
                type: "int72",
            },
            {
                internalType: "int72",
                name: "positionShortFRStored",
                type: "int72",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "oracle_",
                type: "address",
            },
            {
                internalType: "address",
                name: "delegateStorage",
                type: "address",
            },
            {
                internalType: "address",
                name: "fundingRateAccount_",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "soLevel_",
                type: "uint8",
            },
            {
                internalType: "uint16",
                name: "withdrawMarginLevel_",
                type: "uint16",
            },
            {
                internalType: "uint256",
                name: "maxOpenPositions_",
                type: "uint256",
            },
        ],
        name: "setBasicParams",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "int112",
                name: "soLevel_",
                type: "int112",
            },
        ],
        name: "setCustomStopOutLevel",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "delegateStorage_",
                type: "address",
            },
        ],
        name: "setDelegateStorage",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                internalType: "int256",
                name: "dailyFRLong",
                type: "int256",
            },
            {
                internalType: "int256",
                name: "dailyFRShort",
                type: "int256",
            },
        ],
        name: "setFR",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "soLevel",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "matchers",
                type: "address[]",
            },
        ],
        name: "updateMatchers",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint112",
                name: "amount",
                type: "uint112",
            },
        ],
        name: "withdrawAsset",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint112",
                name: "amount",
                type: "uint112",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
        ],
        name: "withdrawAssetTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "withdrawMarginLevel",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
class CrossMarginCFD__factory {
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.CrossMarginCFD__factory = CrossMarginCFD__factory;
CrossMarginCFD__factory.abi = _abi;
